import React, { useState } from 'react';
import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../../hooks/useProfile';
import './AccountLayout.css'; 

const AccountLayout = () => {
  const { profile, loading } = useProfile();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Redirect /account directly to /account/profile if exact match
  if (location.pathname === '/account') {
    return <Navigate to="/account/profile" replace />;
  }

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="account-dashboard-shell">
      
      {/* --- MOBILE HEADER (Visible only on small screens) --- */ }
      <div className="mobile-account-header">
        <span className="mobile-brand">Account</span>
        <button className="hamburger-btn" onClick={toggleSidebar}>
          {isSidebarOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* --- SIDEBAR OVERLAY (Background dim for mobile) --- */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      {/* --- SIDEBAR --- */}
      <aside className={`account-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        
        <div className="sidebar-header">
           {/* You can add a Logo here if you want */}
           <h3 className="sidebar-title">Dashboard</h3>
        </div>

        <nav className="account-nav">
          <div className="nav-group">
            <small className="nav-label">Overview</small>
            
            <NavLink to="/account/usage" onClick={closeSidebar} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              <span className="nav-icon">📊</span> Usage & Plan
            </NavLink>

            <NavLink to="/account/billing" onClick={closeSidebar} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              <span className="nav-icon">💳</span> Billing History
            </NavLink>
          </div>

          <div className="nav-group">
            <small className="nav-label">Workspace</small>
            <NavLink to="/account/gallery" onClick={closeSidebar} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              <span className="nav-icon">🖼️</span> Mockup Gallery
            </NavLink>
          </div>

          <div className="nav-group">
            <small className="nav-label">Settings</small>
            <NavLink to="/account/profile" onClick={closeSidebar} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              <span className="nav-icon">👤</span> Profile
            </NavLink>

            <NavLink to="/account/security" onClick={closeSidebar} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              <span className="nav-icon">🔐</span> Security
            </NavLink>
          </div>
        </nav>

        {/* User Mini Profile at Bottom */}
        <div className="sidebar-footer">
            <div className="user-mini-badge">
                <div className="mini-avatar">{profile?.email?.charAt(0).toUpperCase() || 'U'}</div>
                <div className="mini-info">
                    <span className="mini-name">My Account</span>
                    <span className="mini-email">{profile?.email}</span>
                </div>
            </div>
        </div>
      </aside>

      {/* --- MAIN CONTENT AREA --- */}
      <main className="account-content">
        <Outlet context={{ profile, loading }} />
      </main>
    </div>
  );
};

export default AccountLayout;